import { Button, notification, Space } from 'antd';

const openNotification = data => {
const type = data.result ? 'success' : 'error'
  notification[type]({
    message: data.msg,
  });
};

export { openNotification }